import { Routes, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LayoutComponent } from './layout/layout.component';
import { SearchIdComponent } from './search-id/search-id.component';
import { LimitsComponent } from './limits/limits.component';
import { TobComponent } from './tob/tob.component';
import { ContactComponent } from './contact/contact.component';
import { UpdatePasswordComponent } from './update-password/update-password.component';
import { LoginComponent } from './login/login.component';
import { authGuard } from './Services/auth.guard';
import { AuthService } from './Services/auth.service';

export const redirectGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  if (authService.isAuthenticated()) {
    router.navigate(['/portal/dashboard']);
    return false;
  }
  return true;
};

export const routes: Routes = [
  { path: '', component: LoginComponent, canActivate: [redirectGuard], data: { title: 'Login' } },
  {
    path: 'portal',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [authGuard], data: { title: 'Dashboard' } },
      { path: 'insert-claim', loadChildren: () => import('./insert-claim/insert-claim.module').then(m => m.InsertClaimModule), canActivate: [authGuard], data: { title: 'Insert Claim' } },
      { path: 'searchid', component: SearchIdComponent, canActivate: [authGuard], data: { title: 'Search ID' } },
      { path: 'searchid/:assuredID', component: SearchIdComponent, canActivate: [authGuard], data: { title: 'Search ID' } },
      { path: 'limits', component: LimitsComponent, canActivate: [authGuard], data: { title: 'Limits' } },
      { path: 'tob', component: TobComponent, canActivate: [authGuard], data: { title: 'TOB' } },
      { path: 'contact', component: ContactComponent, canActivate: [authGuard], data: { title: 'Contact' } },
      { path: 'preapproval', loadChildren: () => import('./pre-approval/pre-approval.module').then(m => m.PreApprovalModule), canActivate: [authGuard], data: { title: 'Pre Approval' } },
      { path: 'update-password', component: UpdatePasswordComponent, canActivate: [authGuard], data: { title: 'Update Password' } }
    ]
  },
  { path: '**', redirectTo: 'portal/dashboard' }
];
